import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/video-4-blue.webm";
import avatarVideoMp4 from "../../assets/avatares/video-4-blue.mp4";
import manuelVideo from "../../assets/avatares/juan-hospital.webm";
import manuelVideoMp4 from "../../assets/avatares/juan-hospital.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario4Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Me dices que este tratamiento es diferente… y eso me da algo de esperanza.<br/>Saber que no tengo que estar ingresado todo el tiempo y que se puede llevar de forma más continua… la verdad es que me ayuda a pensar que podré seguir con mi vida.<br/>Después de todo lo que he pasado, no espero milagros… pero sí una oportunidad de que esto funcione y me dé un poco de estabilidad."

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "blue", true);
	};

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO4);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 25000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "50%",
								marginTop: "24px",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-blue h-100 px-5">
						<div className="recuadro-white txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								Decisión terapéutica para el paciente
							</h3>
							<ul>
								<li>Han elegido teclistamab.</li>
								<li>Deben iniciar las dosis de incremento (<i>step-up</i>) los días 1, 4 y 7 para mitigar riesgos.</li>
								<li>La hospitalización no es obligatoria y podría darse en régimen ambulatorio.</li>
								<li>El tratamiento se administra por vía subcutánea.</li>
								<li>Es una administración como tratamiento continuo hasta la progresión de la enfermedad o toxicidad inaceptable.</li>
							</ul>
        					<div className="notaCasoClinicoAutor">caso clínico del autor</div>
						</div>
						<div className="d-flex justify-content-center">
							<div
								className={`button-escuchar-paciente button-escuchar-paciente-blue mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
								aria-disabled={!canOpenDialog}
								onClick={canOpenDialog ? abrirModal : undefined}
								style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
							>
								Escuchar al paciente
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario4Intro);
